// Original source: /Users/matteo/projects/apifrom/apifrom-backend/src/shared/curl.utils.ts
// curl 'https://www.mercatoelettrico.org/it-it/Home/Esiti/Elettricita/MGP/Esiti/PUN' -H 'User-Agent: Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:136.0) Gecko/20100101 Firefox/136.0' -H 'Accept: text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8' -H 'Accept-Language: it-IT,it;q=0.8,en-US;q=0.5,en;q=0.3' -H 'Accept-Encoding: gzip, deflate, br, zstd' -H 'Connection: keep-alive' -H 'Cookie: dnn_IsMobile=False; .ASPXANONYMOUS=pDl2z6hEG4E_H1vQqHeajTVUUOJRMNjZaLOU8kcF0LIzayuajaCOP5cddeMGs8hJsusOG3WtnfnLSPCCvoPlJUPhrrDcGh1B6zNWZRFTqXwBd_8u0; language=it-IT; __RequestVerificationToken=tSUznjPy9QFIGjKtFnVvV6I2AL6Ehy0ts6jTrZtpY6Xt8vyJUWkm-OvME0XCY_rackY_iQ2; GmePolicy_it=true' -H 'Upgrade-Insecure-Requests: 1' -H 'Sec-Fetch-Dest: document' -H 'Sec-Fetch-Mode: navigate' -H 'Sec-Fetch-Site: cross-site' -H 'Priority: u=0, i' -H 'TE: trailers'

import { CurlJson } from "@/shared/model/api-config.model";

/**
 * Convert a curl command to a JSON object
 * @param curlCommand - The curl command to convert
 * @returns A JSON object representing the curl command
 */
export function curlToJson(curlCommand: string): CurlJson {
  // Remove 'curl' from the beginning and trim whitespace
  const cleanCommand = curlCommand.replace(/^\s*curl\s+/, "").trim();

  const result: CurlJson = {
    url: "",
    method: "GET",
  };

  const headers: Record<string, string> = {};
  const cookies: Record<string, string> = {};

  let currentToken = "";
  let isInQuotes = false;
  let isEscaped = false;

  // Split the command while respecting quotes and escapes
  const tokens: string[] = [];

  for (let i = 0; i < cleanCommand.length; i++) {
    const char = cleanCommand[i];

    if (char === "\\" && !isEscaped) {
      isEscaped = true;
      continue;
    }

    if ((char === '"' || char === "'") && !isEscaped) {
      isInQuotes = !isInQuotes;
    } else if (char === " " && !isInQuotes && !isEscaped) {
      if (currentToken) {
        tokens.push(currentToken);
        currentToken = "";
      }
    } else {
      currentToken += char;
    }

    isEscaped = false;
  }

  if (currentToken) {
    tokens.push(currentToken);
  }

  // Parse tokens
  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i];

    if (token.startsWith("-H") || token.startsWith("--header")) {
      const headerValue = tokens[++i];
      const [headerName, headerContent] = headerValue.split(/:\s*/);
      const cleanHeaderName = headerName.replace(/['"]/g, "");
      const cleanHeaderContent = headerContent.replace(/['"]/g, "");

      // Check if this is a Cookie header and parse it
      if (cleanHeaderName.toLowerCase() === "cookie") {
        const cookiePairs = cleanHeaderContent.split(/;\s*/);

        for (const pair of cookiePairs) {
          const [cookieName, cookieValue] = pair.split(/=/);
          if (cookieName && cookieValue) {
            cookies[cookieName] = cookieValue;
          }
        }
      } else {
        headers[cleanHeaderName] = cleanHeaderContent;
      }
    } else if (token.startsWith("-X") || token.startsWith("--request")) {
      result.method = tokens[++i].toUpperCase();
    } else if (token.startsWith("-d") || token.startsWith("--data")) {
      const data = tokens[++i];
      try {
        result.data = JSON.parse(data.replace(/['"]/g, ""));
      } catch {
        result.data = data.replace(/['"]/g, "");
      }
    } else if (token.startsWith("--cookie") || token.startsWith("-b")) {
      const cookieString = tokens[++i].replace(/['"]/g, "");
      const cookiePairs = cookieString.split(/;\s*/);

      for (const pair of cookiePairs) {
        const [cookieName, cookieValue] = pair.split(/=/);
        if (cookieName && cookieValue) {
          cookies[cookieName] = cookieValue;
        }
      }
    } else if (!token.startsWith("-")) {
      result.url = token.replace(/['"]/g, "");
    }
  }

  if (Object.keys(headers).length > 0) {
    result.headers = headers;
  }

  if (Object.keys(cookies).length > 0) {
    result.cookies = cookies;
  }

  return result;
}
